import{__module as r}from"../../../../_virtual/index4.js";import"./cjs/react-is.production.min.js";import{__exports as o}from"../../../../_virtual/react-is.production.min.js";r.exports=o;var t=r.exports;export{t as r};
//# sourceMappingURL=index.js.map
